import(/* webpackMode: "eager" */ "/home/kaydmoc/public_html/belyfted.com/app/(frontend)/layout.jsx");
